"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _underscore = _interopRequireDefault(require("underscore"));
var _utils = require("./dropdown_select/utils");
var _components = require("./dropdown_select/components");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// @ts-expect-error - TS7016 - Could not find a declaration file for module './dropdown_select/components'. 'src/azalea/components/dropdown_select/components.js' implicitly has an 'any' type.

var defaultProps = {
  isSearchable: false,
  isClearable: false,
  isCreatable: false,
  isMulti: false,
  isLazyLoad: false,
  isVirtualized: false,
  isTiered: false,
  isDisabled: false,
  hideDisabledOptions: false,
  options: [],
  placeholder: 'Select...',
  debounceTime: 500
};
function debounce(fn, interval) {
  // @ts-expect-error - TS7034 - Variable 'timer' implicitly has type 'any' in some locations where its type cannot be determined.
  var timer = null;

  // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // @ts-expect-error - TS7005 - Variable 'timer' implicitly has an 'any' type.
    if (timer) {
      // @ts-expect-error - TS7005 - Variable 'timer' implicitly has an 'any' type.
      clearTimeout(timer);
    }
    return new Promise(function (resolve) {
      timer = setTimeout(function () {
        return resolve(fn.apply(void 0, args));
      }, interval);
    });
  };
}

// **********
// Components
// **********
var Dropdown = function Dropdown(props) {
  if ((props.isTiered || props.isVirtualized) && props.isCreatable) {
    throw 'Virtualized and Tiered dropdowns cannot be Creatable. That functionality has not been implemented due to using legacy code';
  }
  var DropdownComponent = (0, _components.getComponent)(props);
  var _useState = (0, _react.useState)(_underscore["default"].isFunction(props.options) ? [] : props.options),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    options = _useState2[0],
    setOptions = _useState2[1];
  var _useState3 = (0, _react.useState)(_underscore["default"].isFunction(props.options) ? function () {
      return props.options;
    } : props.options),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    prevGetOptions = _useState4[0],
    setPrevGetOptions = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    menuIsOpen = _useState8[0],
    setMenuIsOpen = _useState8[1];
  var didArrayOptionsChange = function didArrayOptionsChange() {
    return Array.isArray(props.options) && props.options !== prevGetOptions;
  };
  var didFunctionOptionsChange = function didFunctionOptionsChange() {
    return props.options && prevGetOptions && props.options.toString() !== prevGetOptions.toString();
  };
  if (props.isTiered || props.isVirtualized || props.isLazyLoad) {
    // handle async/lazy loading

    // Reset options and loading state if we get a new function for fetching options
    if (!prevGetOptions || didArrayOptionsChange() || didFunctionOptionsChange()) {
      setIsLoading(false);
      if (typeof props.options === 'function') {
        setOptions([]);
        // in hooks, to save a function in state it must be wrapped like this because
        // useState setter treats a function argument as lazy calculation
        setPrevGetOptions(function () {
          return props.options;
        });
      } else {
        setOptions(props.options);
        setPrevGetOptions(props.options);
      }
    }
    var fetchOptionsIfNeeded = function fetchOptionsIfNeeded() {
      if (_underscore["default"].isFunction(props.options) && options.length === 0 && !isLoading) {
        setIsLoading(true);
        // @ts-expect-error - TS7006 - Parameter 'data' implicitly has an 'any' type.
        props.options('').then(function (data) {
          setOptions(data);
          setIsLoading(false);
        });
      }
    };
    if (!props.isLazyLoad) {
      fetchOptionsIfNeeded();
    }
    if (props.isTiered || props.isVirtualized) {
      return /*#__PURE__*/_react["default"].createElement(DropdownComponent, (0, _extends2["default"])({}, (0, _utils.enhanceProps)(props), {
        options: options,
        isLoading: isLoading,
        onOpen: fetchOptionsIfNeeded,
        noResultsText: (0, _utils.getNoResultsText)(props.noOptionsMessage),
        loadingPlaceholder: (0, _utils.getLoadingPlaceholder)(props.loadingMessage)
      }));
    }
    var handleMenuOpen = function handleMenuOpen() {
      fetchOptionsIfNeeded();
      setMenuIsOpen(true);
      props.onMenuOpen && props.onMenuOpen();
    };
    var handleMenuClose = function handleMenuClose() {
      setMenuIsOpen(false);
      props.onMenuClose && props.onMenuClose();
    };
    return /*#__PURE__*/_react["default"].createElement(DropdownComponent, (0, _extends2["default"])({}, (0, _utils.enhanceProps)(props), {
      isLoading: isLoading,
      menuIsOpen: menuIsOpen,
      onMenuOpen: handleMenuOpen,
      onMenuClose: handleMenuClose,
      options: options
    }));
  } else if (_underscore["default"].isFunction(props.options)) {
    return /*#__PURE__*/_react["default"].createElement(DropdownComponent, (0, _extends2["default"])({}, (0, _utils.enhanceProps)(props), {
      loadOptions: debounce(props.options, props.debounceTime),
      defaultOptions: true
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(DropdownComponent, (0, _extends2["default"])({}, (0, _utils.enhanceProps)(props), {
    options: props.options
  }));
};
Dropdown.defaultProps = defaultProps;
var _default = Dropdown;
exports["default"] = _default;